module.exports = __webpack_public_path__ + "img/blue-white-transition-clean.00ffcece.png";